import { JsonObject, JsonProperty } from 'json2typescript';

/**
 * 会員属性登録用Dto
 */
@JsonObject('ExamineeAttribute')
export default class ExamineeAttribute {
  constructor() {
    this.optionItemCode = undefined;
    this.inputText = undefined;
  }

  @JsonProperty('option_item_code')
  public optionItemCode?: string;

  @JsonProperty('input_text')
  public inputText?: string;
}
